import { createSlice } from "@reduxjs/toolkit";

// Live messages carry full email HTML bodies, so the buffer must stay bounded:
// an open conversation only needs the latest few to append live (it refetches
// the real thread from the server on mount anyway).
const MAX_MESSAGES_PER_THREAD = 15;
const MAX_BUFFERED_THREADS = 10;

const threadSlice = createSlice({
  name: "threads",
  initialState: {
    liveMessages: {},
    lastUpdated: null,
  },
  reducers: {
    addLiveMessage: (state, action) => {
      const { threadId, message, quoteId } = action.payload;

      if (!state.liveMessages) {
        state.liveMessages = {};
      }

      if (!state.liveMessages[threadId]) {
        // Evict the oldest-inserted thread buffers beyond the cap.
        const keys = Object.keys(state.liveMessages);
        while (keys.length >= MAX_BUFFERED_THREADS) {
          delete state.liveMessages[keys.shift()];
        }
        state.liveMessages[threadId] = [];
      }

      state.liveMessages[threadId].push(message);
      if (state.liveMessages[threadId].length > MAX_MESSAGES_PER_THREAD) {
        state.liveMessages[threadId] = state.liveMessages[threadId].slice(
          -MAX_MESSAGES_PER_THREAD
        );
      }

      state.lastUpdated = { threadId, quoteId };
    },
    clearHighlight: (state) => {
      state.lastUpdated = null;
    },
    clearThreadMessages: (state, action) => {
      const { threadId } = action.payload;
      delete state.liveMessages[threadId];
    }
  }
});

export const { addLiveMessage, clearHighlight, clearThreadMessages } = threadSlice.actions;
export default threadSlice.reducer;
